import { createReducer } from 'redux-act';
import * as actions from '#app/actions/goal';

interface GoalState {
  modalVisible: boolean;
  form: Record<string, unknown>;
  goalArchiveModalVisible: boolean;
  goalArchiveForm: Record<string, unknown>;
}

const initialState: GoalState = {
  modalVisible: false,
  form: {},
  goalArchiveModalVisible: false,
  goalArchiveForm: {},
};

const setGoalModalVisible = (state: GoalState, bool: boolean): GoalState => ({
  ...state,
  modalVisible: bool,
});

const setGoalForm = (state: GoalState, form: Record<string, unknown>): GoalState => ({
  ...state,
  form: form,
  modalVisible: true,
});

const closeGoalForm = (state: GoalState): GoalState => ({
  ...state,
  form: {},
  modalVisible: false,
});

const closeGoalArchive = (state: GoalState): GoalState => ({
  ...state,
  goalArchiveForm: {},
  goalArchiveModalVisible: false,
});

const setGoalArchiveForm = (state: GoalState, form: Record<string, unknown>): GoalState => ({
  ...state,
  goalArchiveForm: form,
  goalArchiveModalVisible: true,
});

export default createReducer<GoalState>(
  {
    [actions.setGoalModalVisible as any]: setGoalModalVisible,
    [actions.setGoalForm as any]: setGoalForm,
    [actions.closeGoalForm as any]: closeGoalForm,
    [actions.setGoalArchiveForm as any]: setGoalArchiveForm,
    [actions.closeGoalArchive as any]: closeGoalArchive,
  },
  initialState
);
